import isClient from "../../isClient";
/**
 * Builds the url from an array, sorting out falsy values.
 * @param {string[]} fragments - An array of entries that will be concatenated with /.
 * @param {string} [base] - The base for building the URL.
 * @returns {string} - The URL built by concatening base URL and fragments.
 */
const buildUrl = (fragments = [], base) => {
    let defaultBaseUrl = '';
    if (isClient() && process.env.TYPE_OF_LINK !== 'server') {
        defaultBaseUrl = window.location.origin;
    }
    else if (process.env.NODE_ENVIRONMENT) {
        defaultBaseUrl = process.env.SSR_CONTENT_API_ROOT;
    }
    else {
        defaultBaseUrl = 'http://localhost:8080';
    }
    return [base || defaultBaseUrl]
        .concat(fragments)
        .filter((fragment) => !!fragment)
        .join('/');
};
export default buildUrl;
//# sourceMappingURL=buildUrl.js.map